export const Drawer = {
  sizes: {
    lg: {
      dialog: {
        maxW: 'drawer.lg',
      },
    },
  },
}
